import { useEffect, useLayoutEffect, useMemo } from "react";
import { fetchHomePage, fetchStoreTheme } from "../api/catalog";
import {
  applyStoreTheme,
  clearStoreTheme,
  readCachedStoreTheme,
  storeThemeFromSettings,
  writeCachedStoreTheme,
} from "../lib/storeTheme";

export default function StoreTheme({ storeSlug }) {
  const contentPage = useMemo(
    () => /\/pages\/[^/]+/.test(window.location.pathname),
    []
  );

  useLayoutEffect(() => {
    if (contentPage) return;
    const cached = readCachedStoreTheme(storeSlug);
    if (cached) applyStoreTheme(cached);
  }, [contentPage, storeSlug]);

  useEffect(() => {
    if (contentPage) return undefined;
    let cancelled = false;
    fetchStoreTheme(storeSlug)
      .catch(() => null)
      .then((data) => {
        const storeTheme = storeThemeFromSettings(data?.theme);
        if (storeTheme) return storeTheme;
        return fetchHomePage(storeSlug).then((page) =>
          storeThemeFromSettings(page?.page?.content?.settings)
        );
      })
      .then((theme) => {
        if (cancelled) return;
        writeCachedStoreTheme(storeSlug, theme);
        applyStoreTheme(theme);
      })
      .catch(() => {
        if (!cancelled) {
          writeCachedStoreTheme(storeSlug, null);
          clearStoreTheme();
        }
      });
    return () => {
      cancelled = true;
    };
  }, [contentPage, storeSlug]);

  return null;
}
